export function doubleNumber(num: number): number {
  return num * 2;
}
export function myName(): string {
  return 'Well Do It Too';
}
